import { FileText } from 'lucide-react';
import { Badge } from '@/components/ui';
import type { DispensaryOutsidePrescription } from '@/features/admin-v2/api';
import styles from './dispensary.module.css';

const issued = (iso: string) =>
  new Date(iso).toLocaleString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });

/** RL-1159: queue badge for the outside prescription (ORX-…) of a prescription. */
export function OutsideRxBadge({
  doc,
}: {
  doc: DispensaryOutsidePrescription | null | undefined;
}) {
  if (!doc) return null;
  return doc.revoked ? (
    <Badge icon={<FileText size={12} aria-hidden="true" />}>
      Outside Rx {doc.documentNumber} cancelled
    </Badge>
  ) : (
    <Badge tone="warning" icon={<FileText size={12} aria-hidden="true" />}>
      Outside Rx {doc.documentNumber}
    </Badge>
  );
}

/** RL-1159: the outside prescription on the prescription detail. */
export function OutsideRxDetail({
  doc,
}: {
  doc: DispensaryOutsidePrescription | null | undefined;
}) {
  if (!doc) return <>None issued</>;
  return (
    <div className={styles.outside}>
      <span>
        <span className="mono">{doc.documentNumber}</span> · issued{' '}
        {issued(doc.issuedAt)}{' '}
        {doc.revoked ? (
          <Badge>Cancelled</Badge>
        ) : (
          <Badge tone="warning">Valid at any pharmacy</Badge>
        )}
      </span>
      {doc.revoked ? (
        <span className={styles.hint}>
          Cancelled, so it can no longer be used at a pharmacy.
        </span>
      ) : (
        <p className={styles.warn}>
          The doctor gave the patient a prescription for an outside pharmacy.
          Supplying here will cancel it: confirm with the patient first.
        </p>
      )}
    </div>
  );
}
